// extracted by mini-css-extract-plugin
module.exports = {"textarea":"style__textarea___g5DyY"};